<style type="text/css">
#template-navigator-container {
  position: absolute;
  top: 30px;
  right: 20px;
  z-index: 2;
  width: 350px;
  max-width: calc(100% - 40px);
  @media (min-width: 960px) {
    right: -320px;
    max-width: 300px;
  }
  &.animated {
    transition: opacity 500ms, top 500ms;
  }
}

#navigator-pointer {
  position: absolute;
  color: #818181;
  top: -20px;
  left: 50%;
  transform: translateX(-50%);
  @media (min-width: 960px) {
    left: -20px;
    top: 40px;
    transform: translate(0, -50%)  rotateZ(-90deg);
  }
}

#template-navigator-container.ready {
  opacity: 1;
}

.template-navigator {
  border-radius: 10px;
  z-index: 10;
  overflow: auto;
  background-color: #f5f5f5;
}

.v-list-item__title.isFilled {
  color: red !important;
}

.blob {
  box-shadow: 0 0 0 0 rgba(25, 118, 210, 1);
  transform: scale(1);
  animation: pulse-black 10s infinite;
}

@keyframes pulse-black {
  0% {
    box-shadow: 0 0 0 0 rgba(25, 118, 210, 0.7);
  }

  20% {
    box-shadow: 0 0 0 10px rgba(25, 118, 210, 0);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(25, 118, 210, 0);
  }
}

#template-form {
  box-shadow: -2px -1px 5px 2px rgba(0, 0, 0, 0.2);
}


</style>

<template>
  <div
    v-if="section && $store.state.isEditingToolsVisible"
    :class="!$store.state.activeTemplate.isOnboardingComplete && 'animated'"
    id="template-navigator-container"
  >
    <div class="template-navigator" style="overflow: visible; position: relative;">
      <v-icon
        v-if="!$store.state.activeTemplate.isOnboardingComplete"
        id="navigator-pointer"
      >
        mdi-triangle
      </v-icon>
      <v-card id="template-form" style="border-radius: 10px; position:relative;">
        <v-card-title style="justify-content: space-between; background-color: #F5F5F5; padding: 5px 16px; font-size: 16px;">
          {{ translate(section.id) }}
          <v-btn
            elevation="0"
            fab
            x-small
            @click="onNavigatorClose"
            title="Close navigator"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <div
          class="section-settings-container__form"
          style="padding: 0 16px 16px;"
        >

          <DialogSection
            v-if="shouldShowResourceSectionDialog(section)"
            :section="section.mappedToSection"
            :selectNextSection="selectNextSection"
          />

          <DialogSectionGeneral
            v-if="section.id === 'module_cover'"
            :section="section"
          />

          <div
            v-if="section.id === 'section_timeline'"
          >
            <DialogSectionTimeline
              :section="section"
            />
          </div>

          <DialogSectionWC
            v-if="section.id === 'section_wc' || section.id === 'module_wc'"
            :section="section"
            :selectNextSection="selectNextSection"
          />

          <DialogSectionNPV
            v-if="section.id === 'section_npv' || section.id === 'module_ip'"
            :section="section"
            :selectNextSection="selectNextSection"
          />


        </div>

        <div>
          <div
            style="border-bottom-left-radius: 10px; border-bottom-right-radius: 10px; background-color: #eff6ff; border-top: 1px solid #b7d1ea; padding: 15px;"
          >
            <div v-if="!$store.state.activeTemplate.isOnboardingComplete">
              <div style=" margin-bottom: 10px; font-size: 11px; line-height: 1; display: flex; align-items: center; gap: 8px; text-transform: uppercase; justify-content: space-between;">
              <span style="font-weight: bold; color: #767676;">
                {{ translate('ui_model_walkthrough') }}
              </span>
                <v-btn
                  x-small
                  text
                  @click="$store.state.activeTemplate.isOnboardingComplete = true"
                  style="text-decoration: underline; font-size: 9px;"
                >
                  {{ translate('ui_btn_close') }}</v-btn>
              </div>
            </div>
            <TemplateSectionDescription
              :section="section"
            />


            <div
              v-if="section.mappedToSection && section.mappedToSection.sectionResources"
              style="display: flex; justify-content: center; margin: 10px 0 30px;"
            >
              <v-btn
                x-small
                color="primary"
                @click="editSection(section.mappedToSection)"
                outlined
              >
                <v-icon x-small style="margin-right: 5px;">mdi-cog</v-icon>
                {{ translate('ui_dialog_edit') }} {{ sectionName }}
              </v-btn>
            </div>


            <div
              v-if="!$store.state.activeTemplate.isOnboardingComplete"
              style="display: flex; justify-content: center; align-items: center; margin-top: 20px;"
            >
              <div v-if="this.nextSection">
                <span style="color: dimgrey; line-height: 1.2; font-size: 14px;">{{ translate('ui_next_section') }}:</span>
                <v-btn
                  small
                  class="blob"
                  :disabled="isNextBtnDisabled"
                  color="primary"
                  @click="selectNextSection"
                  style="margin-left: 15px;"
                >
                  {{ translate(this.nextSection.id) }}
                </v-btn>
              </div>

              <v-btn
              v-if="!this.nextSection"
              small
              class="blob"
              :disabled="isNextBtnDisabled"
              color="primary"
              @click="onNavigatorClose"
            >
              {{ translate('ui_btn_end') }}
            </v-btn>
            </div>
          </div>

        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import DialogSectionGeneral from '@/components/dialogs/DialogSectionGeneral';
import DialogSectionTimeline from '@/components/dialogs/DialogSectionTimeline';
import DialogSectionWC from '@/components/dialogs/DialogSectionWC.vue';
import DialogSectionNPV from '@/components/dialogs/DialogSectionNPV.vue';
import TemplateSectionDescription
  from '@/components/sections/TemplateSection/TemplateSectionDescription';
import DialogSection from '@/components/dialogs/DialogSection';

// mixins
import Mixin from '../../mixins/mixin';

export default {
  components: {
    DialogSection,
    TemplateSectionDescription,
    DialogSectionGeneral,
    DialogSectionTimeline,
    DialogSectionNPV,
    DialogSectionWC,
  },
  mixins: [Mixin],
  props: {},
  data: () => ({
    section: null,
    nextSection: null,
    // isScrollAnimated: true,
  }),
  computed: {
    displayNavigatorForSectionsIfOnboarding() {
      const modules = this.$store.state.activeTemplate.data.modules.reduce((arr, module) => {
        if (module.isNavigatable) {
          arr.push(module.id);
        }
        return arr;
      }, []);
      modules.push('section_timeline');
      return modules;
    },
    sectionName() {
      const previewModule = this.$store.state.activeTemplate.data.modules.find((m) => m.mappedToSection && m.mappedToSection.id === this.section.id);
      return this.translate(previewModule ? previewModule.title : this.section.title);
    },
    navigatableSections() {
      // eslint-disable-next-line
      const arr = this.$store.state.activeTemplate.data.modules.filter((module) => {
        const moduleHasSection = module.mappedToSection;
        const isMappedToSectionAndEnabled = (!moduleHasSection && module.isEnabled) || (moduleHasSection && moduleHasSection.isEnabled);
        const isNotHiddenForEditor = !module.hideInEditor;
        return isMappedToSectionAndEnabled && isNotHiddenForEditor;
      });
      const requiredSections = [
        this.getSectionById('section_timeline'),
      ];
      arr.splice(2, 0, ...requiredSections);
      return arr;
    },
    isNextBtnDisabled() {
      return false;
    },
  },
  methods: {
    editSection(section) {
      if (section.id === 'section_cover_preview') {
        // cover preview
        const value = this.$store.state.activeTemplate.isNavigatorVisible === section.id ? null : section.id;
        this.$store.dispatch('updateState', {
          path: 'activeTemplate.isNavigatorVisible',
          value,
        });
      } else {
        const { sections } = this.$store.state.activeTemplate.data;
        const sectionIndex = sections.findIndex((sect) => sect.id === section.id);
        sections[sectionIndex].isEditingSettings = !section.isEditingSettings;
        this.$store.commit('updateState', {
          path: 'activeTemplate.data.sections',
          value: sections,
        });
      }
    },
    shouldShowResourceSectionDialog(section) {
      // const resourceSectionIds = ['section_sales', 'section_sga', 'section_fixedassets', 'section_financing'];
      const resourceSectionIds = ['section_revenue_preview', 'section_sga_preview', 'section_fixedassets_preview', 'section_financing_preview'];
      return resourceSectionIds.includes(section.id);
    },
    onNavigatorClose() {
      this.$store.commit('updateState', {
        path: 'activeTemplate.isOnboardingComplete',
        value: true,
      });
      // make all sections visible
      const { sections } = this.$store.state.activeTemplate.data;
      sections.forEach((sect) => {
        // eslint-disable-next-line
        sect.isEditingSettings = false;
        if (!sect.isInitialized && !sect.isVisible) {
          // eslint-disable-next-line
          sect.isVisible = true;
        }
        // unselect all resources of this section
        if (sect.id === this.section.id && sect.sectionResources) {
          sect.sectionResources.forEach((resource) => {
            // eslint-disable-next-line
            resource.isSelected = false;
          });
        }
      });
      this.$store.commit('updateState', {
        path: 'activeTemplate.data.sections',
        value: sections,
      });
      this.$store.commit('updateState', {
        path: 'activeTemplate.isNavigatorVisible',
        value: false,
      });
      // save template
      this.$store.dispatch('saveRemoteTemplate');

      // remove animated scroll
      // this.isScrollAnimated = false;
    },
    moveNavigator(sectionId) {
      // console.log(sectionId);
      // console.log(this.section);
      const navContainerEl = document.getElementById('template-navigator-container');
      const sectionEl = document.getElementById(sectionId);
      if (sectionEl) {
        const initialTopOffset = 0; // window.scrollY + document.getElementById('module_cover').getBoundingClientRect().top;
        const extraTopOffset = this.$store.state.mode === 'static' ? 150 : 0; // 120;

        const sectionTop = sectionEl.getBoundingClientRect().top + window.scrollY;
        const sectionRight = sectionEl.getBoundingClientRect().x + sectionEl.getBoundingClientRect().width;
        const sectionBottom = sectionEl.getBoundingClientRect().bottom + window.scrollY + 30;
        console.log(this.$vuetify.breakpoint.name + sectionBottom);
        let navContainerElTop = 0;
        switch (this.$vuetify.breakpoint.name) {
          case 'lg':
          case 'xl':
          case 'md':
            // eslint-disable-next-line
            const documentWiderThanEditor = document.body.offsetWidth - sectionRight - navContainerEl.offsetWidth > 0;
            // eslint-disable-next-line
            let rightOffset;
            // console.log(documentWiderThanEditor);
            if (documentWiderThanEditor) {
              rightOffset = document.body.offsetWidth - sectionRight - navContainerEl.offsetWidth - 10;
            } else {
              rightOffset = 10;
            }
            // const rightOffset = document.body.offsetWidth - sectionRight - navContainerEl.offsetWidth; // Math.max(window.innerWidth - sectionRight - 50, 0);
            // const widerThanNavigator = window.innerWidth - sectionRight -
            // console.log(`window.innerWidth: ${document.body.offsetWidth}`);
            // console.log(`sectionRight: ${sectionRight}`);
            // console.log(`rightOffset: ${rightOffset}`);
            navContainerEl.style.right = `${rightOffset}px`; // `${window.innerWidth - sectionRight}`;
            navContainerElTop = sectionTop - initialTopOffset + extraTopOffset;
            break;
          default:
            // navContainerEl.style.left = '10px';
            navContainerElTop = sectionTop + 100;
        }
        navContainerEl.style.top = `${navContainerElTop}px`;

        // if not fully inside the viewport
        const extraBottomOffset = 90;
        if (navContainerElTop + navContainerEl.offsetHeight > window.scrollY + document.documentElement.clientHeight - extraBottomOffset) {
          window.scrollTo({ top: sectionTop - extraBottomOffset, behavior: 'smooth' });
        } else {
          console.log(`${sectionId} not found`);
        }
      }
    },
    selectNextSection() {
      const sectionIndex = this.navigatableSections.findIndex((sect) => sect.id === this.section.id);
      const nextSection = this.navigatableSections[sectionIndex + 1];
      if (nextSection) {
        this.section = nextSection;
        this.nextSection = this.navigatableSections[sectionIndex + 2];
        this.$store.dispatch('updateState', {
          path: 'activeTemplate.isNavigatorVisible',
          value: nextSection.id,
        });
      }
    },
    updateNavigator(sectionId) {
      const targetSectionId = sectionId || this.$store.state.activeTemplate.isNavigatorVisible;
      if (targetSectionId) {
        // eslint-disable-next-line
        const navigatableSection = this.navigatableSections.find((sect) => {
          const previewModuleMatch = sect.id === targetSectionId;
          const sectionMatch = sect.mappedToSection && sect.mappedToSection.id === targetSectionId;
          return previewModuleMatch || sectionMatch;
        });
        if (navigatableSection) {
          this.section = navigatableSection;
          const currentSectionIndex = this.navigatableSections.findIndex((sect) => sect.id === navigatableSection.id);
          this.nextSection = this.navigatableSections[currentSectionIndex + 1];
          // let it display first because it may be hidden
          setTimeout(() => {
            // scroll to active section
            this.moveNavigator(navigatableSection.id);
          }, 0);
        }
      }
    },
  },
  mounted() {},
  watch: {
    '$store.state.isEditingToolsVisible': function () {
      this.updateNavigator();
    },
    '$store.state.isPreviewDataLoaded': function () {
      this.updateNavigator();
    },
    '$store.state.activeTemplate.isNavigatorVisible': function (moduleId) {
      const displayNavigatorForSectionsIfEditing = [
        'module_cover',
        'section_timeline',
        'module_wc',
        'module_ip',
      ];
      const isOnboarding = !this.$store.state.activeTemplate.isOnboardingComplete && this.displayNavigatorForSectionsIfOnboarding.includes(moduleId);
      const isEditing = this.$store.state.activeTemplate.isOnboardingComplete && displayNavigatorForSectionsIfEditing.includes(moduleId);
      if (isOnboarding || isEditing) {
        this.updateNavigator(moduleId);
      }
      if (!moduleId) {
        // hide navigator
        this.section = null;
      }
    },
  },
};
</script>
